import React, { useCallback } from "react";
import Typography from "antd/es/typography";
import Modal from "antd/es/modal";
import colors from "config/colors";
import useModal from "hooks/useModal";
import CameraSvg from "../assets/images/camera.svg"; //change later
import { ResourceType } from "services/resources";
import useAdminResource from "../hooks/useAdminResource";
import AdminLayout from "layouts/Admin.layout";
import { Row, Col, Space } from "components/layout";
import { Title } from "components/Text";
import FormModal from "components/FormModal";
import Table from "components/Table";
import Button from "components/Button";
import Search from "components/Search";
import BtcForm from "../components/forms/Btc.form";
import BtcInfo from "../components/BtcInfo";
import { EditAction, DeleteAction } from "../components/TableActions";
import useResource from 'hooks/useResource';
import { mapDoorsToOptions } from 'helpers/mapToOptions';


const BtcAdminPage = () => {
  const infoModal = useModal();
  const doors = useResource(ResourceType.doors, { prefetch: true });

  const btc = useAdminResource({
    resource: ResourceType.btc,
    resourceName: "BTC",
    searchFields: ["id", "name", "model"],
  });

  const onAction = useCallback(
    (actionType, item) => {
      switch (actionType) {
        case EditAction.actionType:
          btc.onEdit(item);
          btc.reload();
          break;
        case DeleteAction.actionType:
          btc.onDelete(item.id);
          btc.reload();
          break;
        default:
      }
    },
    [btc]
  );

  return (
    <AdminLayout
      title="BTCs"
      icon="clock"
      extra={[
        <Search
          placeholder={btc.strings.searchPlaceholder}
          value={btc.searchVal}
          onChange={(value) => btc.search(value)}
        />,
        <Button
          type="primary"
          icon="plus"
          onClick={() => {
            btc.onCreate({ is_active: 1 });
          }}
        >
          {btc.strings.addButton}
        </Button>,
      ]}
    >
      <FormModal
        title={btc.strings.formTitle}
        form={btc.form}
        submitText={btc.strings.formSubmitButton}
        onClose={() => btc.form.reset()}
      >
        <BtcForm form={btc.form} doorOptions={mapDoorsToOptions(doors.state.list)}/>
      </FormModal>
      <Table
        loading={btc.isLoading}
        dataSource={btc.list}
        actions={[EditAction, DeleteAction]}
        actionsProps={{
          resource: "btc",
        }}
        onAction={onAction}
        rowKey="id"
      >
        <Table.Column title="ID" dataIndex="id" />
        <Table.Column
          title="Name"
          dataIndex="name"
          render={(btcName) => (
            <Typography.Link as="span" style={{ color: colors.primary }}>
              {btcName}
            </Typography.Link>
          )}
          onCell={(item) => {
            return {
              onClick: () => {
                infoModal.show(item);
              },
            };
          }}
        />
        <Table.Column title="Model" dataIndex="model" />
        <Table.Column title="Notes" dataIndex="notes" />
        <Table.Column
          title="Active"
          dataIndex="is_active"
          render={(isActive) => (isActive ? "Yes" : "No")}
        />
      </Table>
      <Modal
        title={"BTC"}
        visible={infoModal.isVisible}
        onCancel={infoModal.hide}
        footer={
          <>
            <Button
              icon="edit"
              onClick={() => {
                infoModal.hide();
                btc.onEdit(infoModal.data);
              }}
            >
              Edit
            </Button>
            <Button
              onClick={() => {
                infoModal.hide();
              }}
            >
              Close
            </Button>
          </>
        }
      >
        <Row style={{ padding: "0 24px" }}>
          <Col span={24}>
            <Space size="large" style={{ marginBottom: "24px" }}>
              <img alt="camera vector" src={CameraSvg} />
              <Title level={4}>{infoModal.data && infoModal.data.name}</Title>
            </Space>
            <BtcInfo btc={infoModal.data} />
          </Col>
        </Row>
      </Modal>
    </AdminLayout>
  );
};

export default BtcAdminPage;
